import Popup from '@Views/comp/Popup';
import { callService, niceCheck, niceCheckDecode } from '@Views/utils/ServiceUtils';
import { getParameterByName, isEmpty, isNull, passwordCheck, sha256 } from '@Views/utils/StringUtils';
import { useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router';

const PasswordChangePopup = ({ title, popupRef, usrIdRef, msg, setUserInfo, msg2 }: any) => {
  const history = useHistory();
  const params: any = useParams();
  const backUrl = params['pageUrl'] ? ('/' + params['pageUrl']) : '/';

  const passwordChange = async () => {
    const oldPassword: any = document.querySelector('#oldPassword');
    const newPassword: any = document.querySelector('#newPassword');
    const confirmPassword: any = document.querySelector('#confirmPassword');

    if (oldPassword.value || newPassword.value || confirmPassword.value) {

      if (isNull(oldPassword.value)) {
        alert(msg['oldPassword'] + msg['inputCheck']);
        oldPassword.focus();
        return;
      }

      if (isNull(newPassword.value)) {
        alert(msg['newPassword'] + msg['inputCheck']);
        newPassword.focus();
        return;
      }


      if (isNull(confirmPassword.value)) {
        alert(msg['confirmPassword'] + msg['inputCheck']);
        confirmPassword.focus();
        return;
      }

      if (!passwordCheck(newPassword.value)) {
        alert(msg['passwordCheck']);
        newPassword.focus();
        return;
      }

      if (oldPassword.value === newPassword.value) {
        alert(msg['passwordVrfc']);
        newPassword.focus();
        return;
      }
    }

    const param: any = {
      usrId: usrIdRef['current']['value']
    };

    param['oldPwd'] = sha256(oldPassword.value);
    param['newPwd'] = sha256(newPassword.value);
    param['cnfmPwd'] = sha256(confirmPassword.value);

    const res = await callService("OBMUD01U02", param);

    if (res['resltCcnt'] === 1) {

      const loginParam = {
        usrId: usrIdRef['current']['value'],
        ecryPwd: param['newPwd']
      }

      const userInfo = await callService("OBMUE01R01", loginParam);
      sessionStorage.setItem("userInfo", JSON.stringify(userInfo))
      setUserInfo(userInfo);
      history.push(backUrl);
    }

  }
  return <>
    <Popup className="modal-sm change-pw" title={title} ref={popupRef}>
      <div className="modal-body">
        <p dangerouslySetInnerHTML={{ __html: msg2 }} />
        <p className="color-4c84ff" dangerouslySetInnerHTML={{ __html: msg['passwordChangeTitle2'] }} />

        <fieldset>
          <div className="form-group">
            <div className="input-box-group">
              <div className="input-box clearfix">
                <label>{msg['oldPassword']}</label>
                <div className="input-group">
                  <input className="form-control" type="password" id="oldPassword" placeholder={msg['oldPassword'] + msg['inputCheck']} />
                </div>
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="input-box-group">
              <div className="input-box clearfix">
                <label>{msg['newPassword']}</label>
                <div className="input-group">
                  <input className="form-control" type="password" id="newPassword" placeholder={msg['newPassword'] + msg['inputCheck']} />
                </div>
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="input-box-group">
              <div className="input-box clearfix">
                <label>{msg['confirmPassword']}</label>
                <div className="input-group">
                  <input className="form-control" type="password" id="confirmPassword" placeholder={msg['confirmPassword'] + msg['inputCheck']} onKeyDown={(e) => { if ((e.code === 'Space' || e.code === 'Enter')) { passwordChange() } }} />
                </div>
              </div>
            </div>
          </div>
          <div className="btn-group btn-130">
            <button type="button" className="btn btn-popup positive" onClick={passwordChange}>{msg['confirm']}</button>
          </div>
        </fieldset>
      </div>
    </Popup>
  </>
}

const Login = ({ msg, setUserInfo }: any) => {
  const history = useHistory();
  const passwordChangePopupRef: any = useRef();
  const usrIdRef: any = useRef();
  const params: any = useParams();
  const backUrl = params['pageUrl'] ? ('/' + params['pageUrl']) : '/';

  let [selectAgePopupActive, setSelectAgePopupActive] = useState<boolean>(false);
  let [selectAge, setSelectAge] = useState<string>('A');
  let writer14Under: any = useRef();

  let [termsPopupActive1, setTermsPopupActive1] = useState<boolean>(false);
  let [termsPopupActive2, setTermsPopupActive2] = useState<boolean>(false);

  let win: any = window;

  let [msg2, setMsg2] = useState<any>();

  const signInClick1 = () => {
    setSelectAgePopupActive(true);
  }

  const signInClick2 = () => {

    if (selectAge === 'A') {
      niceCheck('/SignIn');
    }
    else if (selectAge === 'B') {
      if (isEmpty(writer14Under['current']['value'])) {
        alert('14세 미만 이용자 성명은 필수입력사항 입니다.');
        return;
      }
      else {
        localStorage.setItem('writer14Under', writer14Under['current']['value']);
        niceCheck('/SignIn');
      }
    }

  }

  const idFind = () => {
    history.push('/IdFind');
  }

  const passwordFind = () => {
    history.push('/PasswordFind');
  }

  const loginClick = async () => {
    const usrId: any = document.querySelector('#usrId');
    const ecryPwd: any = document.querySelector('#ecryPwd');

    if (isNull(usrId.value)) {
      alert(msg['usrIdCheck']);
      usrId.focus();
      return;
    }

    if (isNull(ecryPwd.value)) {
      alert(msg['ecryPwdCheck']);
      ecryPwd.focus();
      return;
    }

    const param = {
      usrId: usrId.value,
      ecryPwd: sha256(ecryPwd.value)
    }

    const res = await callService("OBMUE01R01", param, { errorMsgFlag: false });

    let checkCnt: number = 0;

    if (res['detailMsgs']) {
      const errMsg = res['detailMsgs'][0];

      const passwordChangeCodeList = ['BBME00012', 'BBME00010'];

      if (passwordChangeCodeList.indexOf(errMsg['msgCd']) !== -1) {
        if (errMsg['msgCd'] === 'BBME00010') {
          setMsg2('<strong>회원님의 비밀번호는 변경 대상입니다.</strong><br />개인정보보호를 위해 90일 이상 비밀번호를 변경하지 않은 경우<br />비밀번호 변경을 안내하고 있습니다.');
        }
        else if (errMsg['msgCd'] === 'BBME00012') {
          setMsg2('소중한 개인정보 보호를 위해 비밀번호 변경을 부탁드립니다.<br /><strong>비밀번호를 변경하여 주세요.</strong>');
        }
        passwordChangePopupRef['current'].isOpen(true)
      } else {

        //5회 이전 메세지
        if (errMsg['msgCtnt'].length > 65) {

          checkCnt = errMsg['msgCtnt'].substring(64, 65);

          if (checkCnt >= 5) {
            win.confirm(msg['overErrMsg'], function () {
              history.push('/PasswordFind')
            })
          } else {
            alert(errMsg['msgCtnt']);
            return;
          }
        } else {
          let regEx = /[^0-9]/g;
          checkCnt = errMsg['msgCtnt'].replace(regEx, "");
          if (!isEmpty(checkCnt) && checkCnt >= 5) {
            win.confirm(msg['overErrMsg'], function () {
              history.push('/PasswordFind')
            })
          } else {
            alert(errMsg['msgCtnt']);
            return;
          }
        }
      }
    } else {

      if (res['rlnmCertYn'] === 'N') {
        win.confirm("본인인증이후 로그인이가능합니다.", function () {
          niceCheck('/Login');
          sessionStorage.setItem("rlnmCertParam", JSON.stringify({ usrId: usrId.value, pwd: ecryPwd.value }));
        });
      } else {
        sessionStorage.setItem("userInfo", JSON.stringify(res));
        setUserInfo(res);
        history.push(backUrl);
      }
      
    }
  }

  const niceInfoCheck = async () => {
    const encodeData: any = getParameterByName("EncodeData");
    if (isEmpty(encodeData) === false) {
      if (win.opener) {
        win.opener.location = win.location.href;
        win.opener.location.reload();
        win.close();
      } else {
        const rlnmCertParam: any = sessionStorage.getItem("rlnmCertParam");
        const rlnmCertParamJson: any = JSON.parse(rlnmCertParam);

        const niceInfo = await niceCheckDecode(encodeData);
        const userInfo = await callService('OSUUD03R02', { usrId: rlnmCertParamJson['usrId'] });

        const params = {
          usrId: rlnmCertParamJson['usrId'],
          usrNm: niceInfo['name'],
          rlnmCertYn: 'Y',
          cntctEaddr: userInfo['cntctEaddr'],
          oldPwd: rlnmCertParamJson['pwd']
        }
        const updateRes = await callService('OSUUD03U03', params);

        if (updateRes['sucsYn'] === 'Y') {

          const res = await callService("OBMUE01R01", { usrId: rlnmCertParamJson['usrId'], ecryPwd: sha256(rlnmCertParamJson['pwd']) });
          sessionStorage.removeItem('rlnmCertParam');
          sessionStorage.setItem("userInfo", JSON.stringify(res));
          setUserInfo(res);
          history.push(backUrl);
        }
      }
    }
  }

  const onClickBtnAgree = async () => {
    await callService('OBMUE99R02', null);
    history.push(backUrl);
  }

  const onClickBtnCancle = () => {
    setTermsPopupActive1(false)
    history.push(backUrl);
  }

  const onClickRadioAge = (e: any) => {
    const selectedStdRadio: any = document.querySelector('input[name="radio-1"]:checked');
    setSelectAge(selectedStdRadio['value']);
  }

  const OBMUE99R01 = async () => {
    await callService("OBMUE99R01");
  }

  useEffect(() => {
    niceInfoCheck();
    OBMUE99R01();
  }, []);

  return (
    <>
      <div className={"modal fade" + (termsPopupActive1 ? ' show' : '')}>
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <strong className="modal-title" id="staticBackdropLabel">개인정보 수집·이용 재동의</strong>
              <button type="button" className="btn close" data-dismiss="modal" aria-label="Close" onClick={() => { onClickBtnCancle() }}>
              </button>
            </div>
            <div className="modal-comp">
              <div className="txt-con">
                <div className="con-tit">
                  <strong className="tit">개인정보 수집·이용 재동의</strong>
                </div>
                <div className="con-desc">
                  <p>■ 개인정보 수집·이동 동의 <strong className="text-important">(필수) </strong> <button type="button" className="btn btn-show-terms" style={{ color: "blue", padding: 0, borderBottom: "1px solid blue" }} onClick={() => setTermsPopupActive2(true)}>보기</button></p>
                  <p><br /></p>
                  <p>⦁ 개인정보 수집·이용에 재동의하시면 회원관리를 위해 수집된 개인정보의 보유·이용 기간이 2년간 연장됩니다.</p>
                  <p><br /></p>
                  <p>⦁ 회원께서는 개인정보 수집·이용 재동의를 거부하실 수 있으며,<br /> 이 경우 보유·이용 기간 만료일로부터 5일 이내에 귀하의 모든 회원정보가 삭제되고 자동탈퇴 됩니다.</p>
                  <div className="btn-wrap">
                    <div className="form-group form-group-checkbox">
                      <div className="input-box-group">
                        <div className="input-box">
                          <div className="input-group">
                            <button type="button" className="btn btn-popup negative" onClick={() => { onClickBtnCancle() }}>취소</button>
                            <button type="button" className="btn btn-popup positive" onClick={() => { onClickBtnAgree() }}>동의</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={"modal-backdrop fade" + (termsPopupActive1 ? ' show' : '')}></div>

      <div className={"modal fade" + (termsPopupActive2 ? ' show' : '')}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <strong className="modal-title" id="staticBackdropLabel">한국은행 경제통계시스템 개인정보 수집이용 동의</strong>
              <button type="button" className="btn close" data-dismiss="modal" aria-label="Close" onClick={() => { setTermsPopupActive2(false) }}>
              </button>
            </div>
            <div className="modal-body set-height">
              <div className="modal-comp">
                <div className="txt-con">
                  <div className="con-tit">
                    <strong className="tit">경제통계시스템 회원 관리 및 게시글 관리를 위한 개인정보 수집·이용 동의서</strong>
                  </div>
                  <div className="con-desc">
                    <p><span style={{ fontSize: "10pt" }}>  한국은행은 다음의 목적을 위하여 「개인정보 보호법」 제15조 및 제22조에 따라 아래와 같이 개인정보를 수집·이용하고자 합니다. 내용을 읽어 보신 후 동의 여부를 결정하여 주십시오. </span></p>
                    <p><br /></p>
                    <p>■ 개인정보 수집·이용 목적</p>
                    <p><br /></p>
                    <p>가. 회원 관리 : 회원제 서비스 이용, 회원 정보 관리, 분쟁 조정을 위한 기록보존, 공지사항 전달</p>
                    <p>나. 게시글 관리 : Q&A 게시판 질의응답, 원활한 민원처리</p>
                    <p>다. 기타 : 본인확인, 개인식별, 부정이용 방지, 비인가 사용 방지, 홈페이지 개선의견 수집, 접속빈도 파악,</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;서비스 이용에 대한 통계 수집의 목적으로 개인정보를 처리합니다.</p>
                    <p><br /></p>
                    <p>■ 필수정보 수집·이용 내역</p>
                    <p><br /></p>
                    <table cellSpacing="0" cellPadding="0" border={1} style={{ width: "100%", height: "97px", fontSize: "10pt", borderWidth: "0px", borderColor: "rgb(0, 0, 0)", borderCollapse: "collapse", borderStyle: "solid", backgroundColor: "rgb(255, 255, 255)" }}><tbody>
                      <tr>
                        <th style={{ width: "20%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }} scope="col">
                          <p><span style={{ fontWeight: "bold" }}></span><span style={{ fontSize: "10pt" }}><span style={{ fontWeight: "bold" }}>수집·이용 목적</span></span></p>
                        </th>
                        <th style={{ width: "40%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }} scope="col">
                          <p><span style={{ fontWeight: "bold" }}></span><span style={{ fontSize: "10pt" }}><span style={{ fontWeight: "bold" }}>수집·이용 항목</span></span></p>
                        </th>
                        <th style={{ width: "40%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }} scope="col">
                          <p><span style={{ fontWeight: "bold" }}></span><span style={{ fontSize: "10pt" }}><span style={{ fontWeight: "bold" }}>보유·이용 기간</span></span></p>
                        </th>
                      </tr>
                      <tr>
                        <td style={{ width: "8%", height: "48px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }}>
                          <p style={{ lineHeight: "100%" }}><span style={{ fontSize: "10pt" }}>&nbsp;&nbsp;회원 관리</span></p></td>
                        <td style={{ width: "55%", height: "48px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }}>
                          <p style={{ lineHeight: "100%" }}><span style={{ fontSize: "10pt" }}>&nbsp;&nbsp;아이디, 이름, 이메일, 패스워드, 법정대리인 이름(만14세 미만 이용자인 경우)</span></p></td>
                        <td style={{ width: "37%", height: "48px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }}>
                          <p style={{ lineHeight: "100%", fontWeight: "bold", fontSize: "larger" }}>&nbsp;&nbsp;수집일로부터 2년</p></td>
                      </tr>
                    </tbody></table>
                    <p><br /></p>
                    <p>※ 귀하는 위 개인정보 수집·이용에 동의하지 않을 권리가 있습니다. 그러나 동의를 거부할 경우 회원 가입 또는 게시글 작성이 불가합니다.</p>
                    <p><br /></p>
                    <p>■ 선택정보 수집·이용 내역</p>
                    <p><br /></p>
                    <table cellSpacing="0" cellPadding="0" border={1} style={{ width: "100%", height: "97px", fontSize: "10pt", borderWidth: "0px", borderColor: "rgb(0, 0, 0)", borderCollapse: "collapse", borderStyle: "solid", backgroundColor: "rgb(255, 255, 255)" }}><tbody>
                      <tr>
                        <th style={{ width: "20%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }} scope="col">
                          <p><span style={{ fontWeight: "bold" }}></span><span style={{ fontSize: "10pt" }}><span style={{ fontWeight: "bold" }}>수집·이용 목적</span></span></p>
                        </th>
                        <th style={{ width: "40%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }} scope="col">
                          <p><span style={{ fontWeight: "bold" }}></span><span style={{ fontSize: "10pt" }}><span style={{ fontWeight: "bold" }}>수집·이용 항목</span></span></p>
                        </th>
                        <th style={{ width: "40%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }} scope="col">
                          <p><span style={{ fontWeight: "bold" }}></span><span style={{ fontSize: "10pt" }}><span style={{ fontWeight: "bold" }}>보유·이용 기간</span></span></p>
                        </th>
                      </tr>
                      <tr>
                        <td style={{ width: "20%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }}>
                          <p style={{ lineHeight: "100%" }}><span style={{ fontSize: "10pt" }}>&nbsp;&nbsp;회원 관리</span></p></td>
                        <td style={{ width: "40%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }}>
                          <p style={{ lineHeight: "100%" }}><span style={{ fontSize: "10pt" }}>&nbsp;&nbsp;직업</span></p></td>
                        <td style={{ width: "40%", height: "33px", borderWidth: "1px", borderColor: "rgb(0, 0, 0)", borderStyle: "solid" }}>
                          <p style={{ lineHeight: "100%", fontWeight: "bold", fontSize: "larger" }}>&nbsp;&nbsp;수집일로부터 2년</p>
                          <p style={{ lineHeight: "100%", fontWeight: "bold", fontSize: "larger" }}>&nbsp;&nbsp;(단, 재동의시 2년 연장)</p></td>
                      </tr>
                    </tbody></table>
                    <p><br /></p>
                    <p>※ 귀하는 선택정보 수집·이용에 동의하지 않을 권리가 있으며 동의를 거부할 경우에도 회원 가입이 가능합니다.</p>
                    <p><br /></p>
                    <p>2. 기타 고지사항</p>
                    <p>  인터넷 서비스 이용과정에서 IP주소, 쿠키, MAC주소, 서비스 이용기록, 방문기록, 불량 이용기록 등의 개인정보 항목이 자동으로 생성되어 수집될 수 있으며, 이는 홈페이지 개선과 보안대책 수립 등의 목적으로 이용될 수 있습니다.</p>
                    <p><br /></p>
                    <p>※ 개인정보 처리에 관한 자세한 사항은 한국은행 홈페이지(http://www.bok.or.kr)의 “개인정보처리방침”을 참고하시기 바랍니다.</p>
                  </div>
                  <div className="btn-wrap">
                    <button type="button" className="btn btn-popup positive" onClick={() => { setTermsPopupActive2(false) }}>확인</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={"modal-backdrop fade" + (termsPopupActive2 ? ' show' : '')}></div>

      <div className={"modal fade" + (selectAgePopupActive ? ' show' : '')}>
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <strong className="modal-title"></strong>
              <button type="button" className="btn close" data-dismiss="modal" aria-label="Close" onClick={() => { setSelectAgePopupActive(false) }}>
              </button>
            </div>
            <div className="modal-comp">
              <div className="txt-con">
                <div className="con-tit">
                  <strong className="tit">알림</strong>
                </div>
                <div className="con-desc">
                  <h4>이용자 구분 선택</h4>
                  <p><br /></p>
                  <div className="input-box">
                    <div className="input-group" style={{ "textAlign": "center" }}>
                      <input type="radio" name="radio-1" id="radio-1" className="form-control" value="A" defaultChecked={true} onClick={onClickRadioAge} />
                      <label htmlFor="radio-1"><span>일반 이용자(만 14세 이상)</span></label>
                      <input type="radio" name="radio-1" id="radio-2" className="form-control" value="B" style={{ "marginLeft": "25px" }} onClick={onClickRadioAge} />
                      <label htmlFor="radio-2"><span>어린이 이용자(만 14세 미만)</span></label>
                    </div>
                  </div>
                  <p><br /></p>
                  {selectAge === 'A' ?
                    <p>회원가입을 위한 본인인증 절차를 진행합니다.</p>
                    :
                    <div>
                      <p>만 14세 미만 어린이 이용자께서는 보호자(법정대리인)와 함께 가입해주시기 바랍니다.</p>
                      <div className="input-box" style={{ "textAlign": "center" }}>
                        <label>만 14세 미만 이용자 성명 : &nbsp;</label>
                        <input className="form-control form-control-sm" type="text" ref={writer14Under} />
                      </div>
                      <p><br /></p>
                      <p>※ 만 14세 미만 이용자의 법정대리인 동의 안내</p>
                      <p><br /></p>
                      <p style={{ "paddingLeft": "15px" }}>- 만 14세 미만 이용자는 부모 또는 보호자(법정대리인)의 동의가 필요합니다.</p>
                      <p style={{ "paddingLeft": "15px" }}>- 부모 또는 법정대리인이 아닌 자가 본인 또는 타인의 명의를 이용하여 동의를 조작하는 경우 관련 법률에 따라 처벌을 받을 수 있습니다.</p>
                      <p><br /></p>
                      <p>회원가입을 위한 보호자(법정대리인)의 본인인증 절차를 진행합니다.</p>
                    </div>
                  }
                </div>
                <div className="btn-wrap" style={{ "textAlign": "center" }}>
                  <div className="form-group form-group-checkbox">
                    <div className="input-box-group">
                      <div className="input-box">
                        <div className="input-group">
                          <button type="button" className="btn btn-popup positive" onClick={() => { signInClick2() }}>확인</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={"modal-backdrop fade" + (selectAgePopupActive ? ' show' : '')}></div>

      <PasswordChangePopup popupRef={passwordChangePopupRef} msg={msg} usrIdRef={usrIdRef} setUserInfo={setUserInfo} msg2={msg2} />
      <div className="wrap-body-center">
        <div className="bg"></div>
        <div className="log-wrap">
          <div className="log">
            <div className="log-txt">
              <h2 className="log-tit">{msg['title']}</h2>
              <p className="sub-tit" dangerouslySetInnerHTML={{ __html: msg['subTitle'] }}>

              </p>
            </div>
            <div className="log-form">
              <div className="form-group">
                <div className="input-box-group">
                  <div className="input-box">
                    <input className="form-control" id="usrId" type="text" placeholder={msg['usrIdCheck']} ref={usrIdRef} />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="input-box-group">
                  <div className="input-box">
                    <input className="form-control" id="ecryPwd" type="password" placeholder={msg['ecryPwdCheck']} onKeyDown={(e) => { if ((e.code === 'Space' || e.code === 'Enter')) { loginClick() } }} />
                  </div>
                </div>
              </div>
              <div className="find-btn">
                <button type="button" className="btn" onClick={idFind}>{msg['idFind']}</button>
                <button type="button" className="btn" onClick={passwordFind}>{msg['passwordFind']}</button>
              </div>
              <div className="act-btn">
                <button type="submit" className="btn bg-btn" onClick={loginClick}>{msg['title']}</button>
                <button type="button" className="btn bd-btn" onClick={signInClick1}>{msg['signIn']}</button>
              </div>
            </div>
            <div className="log-help-txt">
              <p>{msg['helpTxt2']}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Login;